Drupal.behaviors.slideToggle = (data) => {
  return {
    isOpen: !!data && !!data.isOpen,

    checkbox: {
      '@click': () => {
        this.isOpen = this.$el.checked;
      },

      // 'x-init': () => {
      //   console.log('this.$el',this.$el);
      //   this.$el.checked = this.isOpen;
      // },
    },
  };
};
